import axiosInstance from "../utils/axiosInstance";
import { POST_PURCHASE_ORDER_LOG } from "./CONSTANTS";

/**
 * Sends Chrome extension / PO debug logs to the backend for server-side logging
 *
 * @param {string} message — Full log text (e.g. instruction prefix + truncated logs)
 * @returns {Promise<object>}
 */
export const sendPurchaseOrderExtensionLog = (message) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(POST_PURCHASE_ORDER_LOG(), { message })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      console.error("purchaseOrderLogService > sendPurchaseOrderExtensionLog", error);
      reject(error);
    }
  });
};
